module.exports = __webpack_public_path__ + "img/postpay.0708af7e.png";